import { ButtonProps, Button as DSButton, LinkProps } from "@opensea/ui-kit"
import React, { ElementRef, forwardRef } from "react"
import { Link } from "../Link"

export const Button = forwardRef<ElementRef<typeof DSButton>, ButtonProps>(
  function NextButton(props, ref) {
    return (
      <DSButton
        renderLink={Link as React.ComponentType<LinkProps>}
        {...props}
        ref={ref}
      />
    )
  },
)
